export default {
    parseStatus(id){
        if(id===-1) return "Voided"
        else if(id===0) return "Draft"
        else if(id===1) return "Sealed"
        else if(id===2) return "Admin Sealed"
        else if(id===3) return "Delivery Scheduled"
        else if(id===4) return "Pending Reschedule"
        else if(id===5) return "Out For Delivery"
        else if(id===6) return "Delivered"
    },
    getStatusColor(s){
        let color = 'grey'
        if(s===-1) color = 'warning'
        if(s===0) color = 'info'
        if(s===1) color = 'success'
        return color
    },
    parseAppointmentStatus(id){
        if(id===-2) return "Customer Cancelled"
        if(id===-1) return "User Cancelled"
        else if(id===0) return "Pending"
        else if(id===1) return "Started"
        else if(id===2) return "Complete"
        else if(id===3) return "Sealed"
    },
    getAppointmentStatusColor(s){
        let color = 'grey'
        if(s===-2) color = 'error'
        if(s===-1) color = 'error'
        if(s===0) color = 'warning'
        if(s===1) color = 'success'
        if(s===2) color = 'info'
        if(s===3) color = 'purple white--text'
        return color
    },
    formatDate(d, type="short"){
        if(!d) return "None";
        if(d==0) return "None";
        if(type=="short")
            return (new Date(d)).toLocaleDateString('en-TT')
        if(type=="long")
            return (new Date(d)).toLocaleDateString('en-TT', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
        if(type=="withTime")
            return (new Date(d)).toLocaleDateString('en-TT') + ' ' + this.formatTime(d)
    },
    formatTime(t){
        if(!t) return "None";
        return (new Date(t).toLocaleTimeString('en-TT'))
    },
    formatCurrency(value){
        if(value===null || value===undefined) return "";
        let formatter = new Intl.NumberFormat('en-TT', {
          style: 'currency',
          currency: 'TTD'
        });
        return formatter.format(parseFloat(value));
    },
    customFormatDate(date, param=null){
        date = new Date(date);
        date = new Date(date.setHours(date.getHours()+4)); //might not work on the server
        let options = {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: true
        }
        if(param && param == "notime"){
            let s = date.toLocaleString("en-TT", options).split(",") 
            return s[0]+","+s[1]
        }
        return date.toLocaleString("en-TT", options);
    },
    formatForStartAppointmentCalendar(date){
        date = new Date(date);
        date = new Date(date.setHours(date.getHours()+4)); //might not work on the server
        let str = `${date.getFullYear().toString()}-${(date.getMonth()+1).toString().padStart(2,'0')}-${(date.getDate()).toString().padStart(2,'0')} ${date.getHours()}:${date.getMinutes()}`
        return str
    },
    formatForEndAppointmentCalendar(date, duration=90){
        date = new Date(date);
        date = new Date(date.setHours(date.getHours()+4)); //might not work on the server
        let hrs = date.getHours() + Math.floor(duration/60)
        let mins = date.getMinutes() + duration%60
        if(mins == 60){
            mins = 0
            hrs += 1
        }
        console.log(hrs,mins)
        let str = `${date.getFullYear().toString()}-${(date.getMonth()+1).toString().padStart(2,'0')}-${(date.getDate()).toString().padStart(2,'0')} ${hrs.toString().padStart(2,'0')}:${mins.toString().padStart(2,'0')}`
        return str
    },
    parseDate(date, type){
        if(!date){
            return ""
        }
        switch (type) {
            default:
                return new Date(date).toISOString().substring(0, 10);
            case 1:
                return new Date(date).toISOString().replace(/-/g, '/').replace(/T.+/, '')
            case 2:
                return new Date(new Date(date).toISOString().replace(/-/g, '/').replace(/T.+/, '')).toDateString()
            case 3:
                return new Date(new Date(date)).toLocaleString();
        }
    },
    convert24HourTime(time){
        let r;
        if(!time) return false
        r = time.split(':').join("")
        if(r < 1200){
            r = time + " AM"
        }else {
            let tHrs = time.split(":")[0]
            let tMin = time.split(":")[1]

            if(tHrs > 12){
                tHrs = tHrs - 12
            }

            r =  tHrs + ":" + tMin + " PM"
        }
        console.log(time)
        return r 
    }
}